import { HeaderName } from '../HeaderName';
import { getServiceNameFromUrl } from '../services';
let sasApplicationNameHeader;
export const setSASApplicationNameHeader = header => {
  // replace registered mark with empty string
  if (header) {
    sasApplicationNameHeader = header.replace(/®/g, '');
  }
  return sasApplicationNameHeader;
};
export const getSASApplicationNameHeader = () => {
  return sasApplicationNameHeader;
};
export const addSASAppNameHeader = config => {
  const serviceName = getServiceNameFromUrl(config.url);
  if (serviceName && !config.headers[HeaderName.SASApplicationName] && sasApplicationNameHeader) {
    config.headers[HeaderName.SASApplicationName] = sasApplicationNameHeader;
  }
  return config;
};
//# sourceMappingURL=sas-app-name-header.js.map